import { render, staticRenderFns } from "./wxerweimaLogin.vue?vue&type=template&id=3741606c&scoped=true"
import script from "./wxerweimaLogin.vue?vue&type=script&lang=js"
export * from "./wxerweimaLogin.vue?vue&type=script&lang=js"
import style0 from "./wxerweimaLogin.vue?vue&type=style&index=0&id=3741606c&lang=css"
import style1 from "./wxerweimaLogin.vue?vue&type=style&index=1&id=3741606c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3741606c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3741606c')) {
      api.createRecord('3741606c', component.options)
    } else {
      api.reload('3741606c', component.options)
    }
    module.hot.accept("./wxerweimaLogin.vue?vue&type=template&id=3741606c&scoped=true", function () {
      api.rerender('3741606c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/components/loginModal/wxerweimaLogin.vue"
export default component.exports